<template>
  <div class="wg-row warehouse-menu" style="height:calc(100vh - 60px);">
    <!-- Sub menu con scelta categorie -->
    <world-sub-menu :selected="pageId" :list="list" @changePage="changePage">
      <template v-slot:content>
        <!-- Products -->
        <warehouse-products v-if="pageId === 'warehouseProducts'"></warehouse-products>
        <!-- Movements -->
        <warehouse-movements v-if="pageId === 'warehouseMovements'"></warehouse-movements>
        <!-- Vircos materials lists -->
        <vircos-material-lists v-if="pageId === 'vircosMaterialLists'"></vircos-material-lists>
        <!-- Vircos models -->
        <vircos-models v-if="pageId === 'vircosModels'"></vircos-models>
      </template>
    </world-sub-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldSubMenu from "../../../../world/spa/components/WorldSubMenu.vue";
import WarehouseProducts from "./WarehouseProducts.vue";
import WarehouseMovements from "./WarehouseMovements.vue";
import VircosMaterialLists from './VircosMaterialLists.vue';
import VircosModels from './VircosModels.vue';

export default {
  data() {
    return {
      loading: false,
      pageId: "warehouseProducts",
      // Version
      version: process.env.VERSION
    };
  },
  components: {
    WorldSubMenu,
    WarehouseProducts,
    WarehouseMovements,
    VircosMaterialLists,
    VircosModels
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      workSelected: state => state.workSelected,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }),
    list() {
      //Bisogna fare controllo licenza vircos
      const list = [];
      list.push({
        id: "warehouseProducts",
        img: this.$anm22.icons.getWorldIcon("package"),
        label: this.$anm22.strLang(
          this.lang,
          "Products",
          "Prodotti"
        )
      });
      list.push({
        id: "warehouseMovements",
        img: this.$anm22.icons.getWorldIcon("shippingTruck"),
        label: this.$anm22.strLang(
          this.lang,
          "Movements",
          "Movimenti"
        )
      });
      if (this.workSelected == 16) {
        list.push({
          id: "vircosMaterialLists",
          img: this.$anm22.icons.getWorldIcon("menuTable"),
          label: this.$anm22.strLang(
            this.lang,
            "Material lists",
            "Distinte base"
          )
        });
        list.push({
          id: "vircosModels",
          img: this.$anm22.icons.getWorldIcon("ruler"),
          label: this.$anm22.strLang(
            this.lang,
            "Models",
            "Modelli"
          )
        });
      }
      return list;
    }
  },
  methods: {
    changePage(elem) {
      if (typeof elem == "string") {
        elem = this.list.find(l => l.id === elem);
      }
      this.pageId = elem.id;
    }
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, "Warehouse", "Magazzino") + ' | ANM22 Tasks';
    this.$store.dispatch("works/load", this.$vlf("works"));
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Warehouse", "Magazzino")
    );
    this.$Progress.finish();
  }
};
</script>

<style lang="scss" scoped>
.qrcode {
  display: block;
  margin: 0 auto;
  padding: 10px;
  width: 150px;
  height: 150px;
}
</style>


<style lang="scss">
.warehouse-menu .sub-menu-li .item-icon {
  opacity: 0.6;
}
</style>